export default "__VITE_ASSET__CwZ2lTNa__"